import script from "./SupportEmailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportEmailModal.vue?vue&type=script&setup=true&lang=js"

import "./SupportEmailModal.vue?vue&type=style&index=0&id=d58cb43e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d58cb43e"]])

export default __exports__